<template>
  <div>
    <table class="tableList" border="1">
        <tr>
            <th class="cehckbox" width="30"><div><input id="checkAll"  @click="handleCheckAll" type="checkbox"></div></th>
            <th v-for="(itme,index) in tableHead" :key="index">
                <div>
                    {{itme.title}}
                </div>
            </th>
        </tr>
        <tr v-for="(itme,index) in tableList" :key="index">
            <td  class="cehckbox">
                <div>
                   <input name="verify" @click="checkedData(itme,index)" type="checkbox">
                </div>
            </td>
            <td><div class="text"><span>{{itme.splace==0 ? '' : itme.splace}}</span></div></td>
            <td><div class="text"><span>{{itme.grp}}</span></div></td>
            <td><div class="text">{{itme.lane?itme.lane:''}}</div></td>
            <td><div class="text">{{itme.unitNameCHN}}</div></td>
            <td><div class="text" v-for="(obj,i) in itme.items"><div>{{obj.unitNameCHN}}</div>{{obj.familyNameCHN}}{{obj.givenNameCHN}}</div></td>
            <td><div class="text">{{itme.showResult}}<div v-if="itme.sporterState== -1||itme.sporterState == -9||itme.sporterState == -13">{{getsporterState(itme.sporterState)}}</div> </div></td>
            <td><div class="text">{{itme.auditState===1?'已审核':itme.auditState===-1?'审核未通过':'未审核'}}</div></td>
            <td width="162">
                <div class="text czBut">
                    <span v-if="getUnitID(itme) &&  getGameNames.gameState===1 || getGameNames.gameState===2 ||  !getGameNames.gameState">
                        <Button v-if="!itme.auditState && getGameNames.gameState!==2 ||  !getGameNames.gameState" type="info" size="small"   @click="relayUp(itme,false)">编辑</Button>
                        <Button v-if="!itme.auditState" class="delData" type="error" size="small"   @click="trackDel(itme,1)">删除</Button>
                        <Button v-if="!itme.auditState && authorities" class="delData" type="success" size="small"   @click="trackDel(itme,2)">审核</Button>
                        <Button v-if="!itme.auditState && authorities" class="delData" type="error" size="small"   @click="trackDel(itme,4)">不通过</Button>
                        <Button v-else-if="itme.auditState && authorities" class="delData" type="error" size="small"   @click="trackDel(itme,3)">取消审核</Button>
                        <Button v-if="!itme.auditState && isImg(itme.imageUrl)" class="delData" type="info" size="small"   @click="domFile(itme.imageUrl)">下载</Button>
                    </span>
                    <Button  size="small"   @click="relayUp(itme,true)">详情</Button>
                </div>
            </td>
        </tr>
        <tr v-if="tableList.length==0" >
            <td class="noData" :colspan="tableHead.length+1">暂时没有数据...</td>
        </tr>
    </table>
    <audit-reason v-if="reason.reasonModel" @reasonFormSubmit="reasonFormSubmitF" :reason="reason"></audit-reason>
    <iframe :src="fileUrl" style="overflow:hidden;height:0px;width:0;" frameborder="0"></iframe>
  </div>
</template>

<script>
import auditReason from '@/public/auditReason'

export default {
  /*
    group判断是否为综合成绩
  */
  props: ['resultData'],
  components: {
      auditReason
  },
  data () {
    return {
        fileUrl:'',
        reason:{
            reasonModel:false,
        },
        copyResultData:{},
        tableHead: [
            {
                title: '名次',
            },
            {
                title: '组号',
            },
            {
               title: '道次',
               trackType:true
            },
            {
                title: '单位',
            },
            {
                title: '姓名',
            },
            {
                title: '成绩',
            },
            {
                title: '审核状态',
            },
            {
                title: '操作',
            }
        ],
        cradeTitle:''
    
    }
  },
   methods: {
    isImg(url)
    {
        if(url)
        {
            if(url.indexOf('.jpg')!=-1||url.indexOf('.JPG')!=-1||url.indexOf('.PNG')!=-1||url.indexOf('.png')!=-1)
            {
               return false;
            }else{
                return true;
            }
        }else{
            return false; 
        }
    },
   domFile(url)
    {
        let time =new Date().getTime();
        this.fileUrl = `${this.$imgUrl}/api/resources/respource?path=${url}&isDownload=true&time=${time}`;
    },
     getUnitID(itme)//判断是否为本单位
    {
       return localStorage.scoreEntryId==itme.scoreEntryId || JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin || JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
    trackDel(obj,type)
    {
        let str = '';
        if(type==2)
        {
            obj.types = 2;
            str = '通过审核';
        }else if(type==3)
        {   
            obj.types = 3;
            str = '取消审核';
        }else if(type==4)
        {   
            obj.types = 4;
            str = '不通过审核';
        }else{
            str = '删除';
            obj.types = 1;
        }
        
        this.copyResultData = this.$PlugIn.deepClone(obj);
        if(type!==4)
        {   
            this.$Modal.confirm({
                title: '提示',
                content: '<p>您确定要'+str+'吗？</p>',
                onOk: () => {
                    this.$emit('onDelData',this.copyResultData);
                }
            });
        }else{
            this.reason.reasonModel = true;
        }
        
    },
    reasonFormSubmitF(data)
    {
        this.copyResultData.auditUnPassReason = data ? data : '';
        this.$emit('onDelData',this.copyResultData);
        this.reason.reasonModel = false;
    },
    checkedData()
    {
        let verify = document.getElementsByName('verify');
        let checkAll = document.getElementById('checkAll');
        for(let i = 0; i<verify.length;i++)
        {
            if(!verify[i].checked)
            {
                checkAll.checked = false;
                break;
            }else{
                checkAll.checked = true;
            }
        }
    },
    handleCheckAll () {
       let verify = document.getElementsByName('verify');
       let checkAll = document.getElementById('checkAll');
       for(let i = 0; i<verify.length;i++)
       {
           if(checkAll.checked)
           {
               verify[i].checked = true;
           }else{
               verify[i].checked = false;
           }
           
       }
    },
    relayUp(obj,up)
    {
        this.$emit('trackUpShow',{data:obj,up:up});
    },
    getsporterState(state)
    {
        let str = '';
        if(state==-1)
        {
            str = 'DQ';
        }else if(state==-13)
        {
            str = 'YC';
        }else if(state==-9){
            str = 'DT';
        }
        return str;
    }
   },
  computed: {
    authorities()
    {
      return JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin || JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
    tableList()//返回成绩列表数据
    {
        if(!this.resultData.data)
        {
            return [];
        }else{
            return this.resultData.data;
        }
    },
    getGameNames()
    {
      return this.$store.state.unitAllData.gameName
    },
  },
  created () {
   
  }
}
</script>
<style scoped>
    .tableList{width: 100%;margin-top: 22px;text-align: center;}
    .tableList td,.tableList th{padding: 8px 4px;}
</style>




// WEBPACK FOOTER //
// src/components/EventTypeRelay.vue